import { useEffect, useRef } from 'react';

/**
 * PRO (abonelik) ekranını açma isteği (2026-10-29, kullanıcı kararı: ücretsiz planda PRO adımları da görünür, hakkı yoksa
 * basınca PRO ekranı). İsteyen yer (App › openPlanTarget, sesli koç süresi dolunca) bayrak bırakır ve olay yayar: o an açık
 * ekran (MainApp ya da ders seçim ekranı) olayı yakalar; ekran o sırada kuruluyorsa açılışta bayrağı okur.
 */
const KEY = 'kpss_open_pro';
const EVENT = 'kpss-open-subscription';

export function requestProScreen(reason = '') {
    try { sessionStorage.setItem(KEY, reason || '1'); } catch { /* yok */ }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { reason } }));
}

function takeProRequest(): string | null {
    try {
        const v = sessionStorage.getItem(KEY);
        if (v) sessionStorage.removeItem(KEY);
        return v;
    } catch { return null; }
}

/** Abonelik penceresi olan ekranlar çağırır; `reason` boş değilse kullanıcıya gösterilecek kısa açıklamadır */
export function useProRequest(open: (reason: string) => void) {
    const ref = useRef(open);
    ref.current = open;
    useEffect(() => {
        const first = takeProRequest();
        if (first) ref.current(first === '1' ? '' : first);
        const h = (e: Event) => {
            if (!takeProRequest()) return; // başka ekran zaten açtı
            ref.current(((e as CustomEvent).detail?.reason as string) || '');
        };
        window.addEventListener(EVENT, h);
        return () => window.removeEventListener(EVENT, h);
    }, []);
}
